const RekaiFallback = () => {
  return (
    <div className="max-w-[1200px] mx-auto lg:px-5 relative">
      <div className="mdplus:mx-0">
        <div className="flex overflow-scroll no-scrollbar lg:overflow-hidden my-4 font-icb text-black500">
          <div className="text-lg mdplus:text-xl mr-1 text-blue700 underline flex-shrink-0">
            Populära bostäder
          </div>
          <div className="text-lg mdplus:text-xl ml-3 mdplus:ml-5 mr-1 flex-shrink-0">
            Njut av din fritid
          </div>
          <div className="text-lg mdplus:text-xl ml-3 mdplus:ml-5 mr-1 flex-shrink-0">
            Drömvillan
          </div>
          <div className="text-lg mdplus:text-xl ml-3 mdplus:ml-5 mr-1 flex-shrink-0">
            Stadskänsla
          </div>
          <div className="text-lg mdplus:text-xl ml-3 mdplus:ml-5 pr-18 flex-shrink-0">
            Bra energiklass
          </div>
        </div>
      </div>
      <div className="swiper-wrapper overflow-hidden">
        <div className="pb-8">
          <div className="swiper-slide !h-[347px] items-start !w-[322px] lg:!w-[320px] mr-4 rounded-md overflow-hidden bg-grey50"></div>
        </div>
        <div className="pb-8">
          <div className="swiper-slide !h-[347px] items-start !w-[322px] lg:!w-[320px] mr-4 rounded-md overflow-hidden bg-grey50"></div>
        </div>
        <div className="pb-8">
          <div className="swiper-slide !h-[347px] items-start !w-[322px] lg:!w-[320px] mr-4 rounded-md overflow-hidden bg-grey50"></div>
        </div>
        <div className="pb-8">
          <div className="swiper-slide !h-[347px] items-start !w-[322px] lg:!w-[320px] mr-4 rounded-md overflow-hidden bg-grey50"></div>
        </div>
      </div>
    </div>
  );
};

export default RekaiFallback;
